import { useEffect } from "react";
import EngineSchematic from "../components/EngineSchematic";

/* WebView-friendly embed of the Engine Schematic.
   Renders just the <EngineSchematic /> with no navbar, no footer,
   no page chrome. Designed for use inside a React Native WebView in
   the TRT Plus mobile app (or any other host).

   Optional query params:
     ?header=0        — hide the eyebrow + headline above the schematic
     (default: header shown)

   Marked noindex so search engines don't crawl this surface. */
export default function EngineEmbed() {
    useEffect(() => {
        document.title = "TRT Plus · Engine Schematic";

        // No-index this route — it's for in-app embed, not for SEO
        const noindex = document.createElement("meta");
        noindex.setAttribute("name", "robots");
        noindex.setAttribute("content", "noindex, nofollow");
        document.head.appendChild(noindex);

        // Lock the body background so WebView edges always read pure black
        const prevBg = document.body.style.background;
        document.body.style.background = "#000";

        return () => {
            document.head.removeChild(noindex);
            document.body.style.background = prevBg;
        };
    }, []);

    const params = new URLSearchParams(window.location.search);
    // Header is opt-IN via ?header=1. Prerender (and the mobile-app
    // WebView) load without this param → no header baked into the
    // static HTML → no flash of the marketing headline before React
    // re-reads the URL. If a caller wants the full standalone chrome
    // for a public demo, they add ?header=1.
    const showHeader = params.get("header") === "1";
    // ?center=1 → renders only the central interactive schematic
    // (hub + spider network + live caption). For embedding inside the
    // mobile app's modal documentation — strips everything else.
    const centerOnly = params.get("center") === "1";

    return (
        <main
            data-testid="engine-embed-page"
            className="relative bg-black text-[#f4f5f7] font-body min-h-screen"
            style={{
                /* Generous padding so the schematic breathes inside any
                   WebView frame regardless of safe-area insets.
                   Center-only mode uses tighter padding since there's
                   no surrounding chrome to push away from. */
                padding: centerOnly ? "12px 8px 20px" : "32px 20px 56px",
            }}
        >
            <EngineSchematic showHeader={showHeader && !centerOnly} centerOnly={centerOnly} />
        </main>
    );
}
